export class InvalidPortalRequestedException extends Error {
  constructor(message) {
    super(message);
  }
}
